import { InjectionToken } from '@angular/core';

/**
 * The dedicated Web Worker hosting the FlexSearch index (`flexsearch.worker.ts`),
 * or `null` when Web Workers are unavailable or FlexSearch is disabled via
 * `search.flexsearch.enabled=false` (see `provideFlexsearchWorker`).
 * {@link FlexsearchWorkerService} consumes it.
 */
export const FLEXSEARCH_WORKER = new InjectionToken<Worker | null>('FLEXSEARCH_WORKER');
